// Minimum contract every stored item must satisfy so the generic stores can
// reject schema-mismatched blobs without knowing the per-game shape.
export interface SchemaVersioned {
  readonly version: number;
}

// 9-char base36 — collision risk negligible at this storage scale (≤50 records
// per slot, one active game per slot).
export function generateId(): string {
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
}
